import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import customer_router from "./customer_router";
import admin_router from "./admin_router";
import login_router from "./login_router";
import store from "./store/store";
import Vuebar from "vuebar";
import "./plugins/base";
import VueSkycons from "vue-skycons";
import InstantSearch from "vue-instantsearch";
import JsonCSV from 'vue-json-csv';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import Donut from 'vue-css-donut-chart';
import 'vue-css-donut-chart/dist/vcdonut.css';
import PrimeVue from 'primevue/config';
import axios from 'axios';
Vue.use(PrimeVue);

Vue.use(Donut);

Vue.use(VueSweetalert2);

Vue.component('downloadCsv', JsonCSV);

Vue.use(VueSkycons, {
  color: "#1e88e5",
});
Vue.use(InstantSearch);
Vue.config.productionTip = false;
Vue.use(Vuebar);

Vue.prototype.$adminapiurl = '/';
Vue.prototype.$apiurl = '/';

console.log('ABCCHECK---------------->');

document.addEventListener("visibilitychange", () => {
  if (document.visibilityState === "visible") {
    axios.get(Vue.prototype.$apiurl + "api/web/common/auth-check").catch(() => {});
  }
});
let sessionInterval = null;

function startSessionPolling() {
  if (sessionInterval) return;

  sessionInterval = setInterval(() => {
    axios.get(Vue.prototype.$apiurl + "api/web/common/auth-check").catch(() => {
      // interceptor handles logout
    });
  }, 5000); // every 5 seconds
}

if (localStorage.getItem("token")) {
  startSessionPolling();
}


axios.interceptors.response.use(
  response => response,
  error => {
    let raw = error.response?.data;

    // console.log(error.response.data);
    // console.log(error.response.data[0].status);
    // console.log(error.response.data.status);
    // console.log(error.response.data[0]['status']);
    // console.log('123check------------>');

    const status = error.response?.status
      || (typeof raw === "object" && raw !== null && raw.code)
      || (typeof raw === "string" && (() => {
          const match = raw.match(/\[status\]\s*=>\s*(\d+)/);
          return match ? parseInt(match[1], 10) : null;
        })());

    if (status === 401 || status === 403) {
      localStorage.removeItem("token");
      localStorage.clear();
      window.location.href = "/authentication/logout";
    }

    return Promise.reject(error);
  }
);


async function bootstrap() {
  try {
    const res = await axios.get(Vue.prototype.$apiurl + "api/web/site/get-maintenance-status")
    // store.commit('SET_MAINTENANCE', res.data.data[0].status)
    // console.log(res.data.data[0].status);

    const status = res.data.data[0].status // "ON" or "OFF"
    const maintenance = status === 'ON'

    store.commit('SET_MAINTENANCE', maintenance)

    console.log('main.js-------->');
  } catch (err) {
    console.error('Failed to load maintenance status', err)
  }


  let users = JSON.parse(localStorage.getItem("users"));
  console.log(users);
  console.log('jan9------->');
  let user_type = '';
  let site_id = '';
  if(users != null){
    user_type = users[3]['user_type'];
    site_id = users[2]['site_id'];
  }
  if(user_type == ''){
    new Vue({
      vuetify,
      store,
      router:login_router,
      render: (h) => h(App),
    }).$mount("#app");
  }
  else if(user_type == 'Customer'){
    new Vue({
      vuetify,
      store,
      router:customer_router,
      render: (h) => h(App),
    }).$mount("#app");
  }else if(site_id == 0){
    new Vue({
      vuetify,
      store,
      router:admin_router,
      render: (h) => h(App),
    }).$mount("#app");
  }else{
    new Vue({
      vuetify,
      store,
      router:router,
      render: (h) => h(App),
    }).$mount("#app");
  }

  // new Vue({
  //   router,
  //   store,
  //   render: h => h(App)
  // }).$mount('#app')
}

bootstrap()